







import Vue from 'vue'

import supplierSearchPage from '../supplier-search-page.vue'

import { ProductMainInfo } from '@/types/supplier-search'

export default Vue.extend({
name: 'byProductSSF',
  components: {
    supplierSearchPage
  },
  mounted() {
    window.supplierSearchEventBus.$on('show-supplier-search-window', (data: ProductMainInfo) => {
      this.ignite = true
      this.dataFromExternal = data;
    });
  },
  data() {
    return {
      ignite: false,
      dataFromExternal: {} as ProductMainInfo
    }
  },
})
